// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/attachment.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_attachment_kind } from "./attachment_kind_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/attachment.proto.
 */
export const file_studyo_today_planners_v1_resources_attachment = /*@__PURE__*/
  fileDesc("CjNzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2F0dGFjaG1lbnQucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMirQEKCkF0dGFjaG1lbnQSQAoEa2luZBgBIAEoDjIyLnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuQXR0YWNobWVudEtpbmQSDQoFdGl0bGUYAiABKAkSFQoNdGh1bWJuYWlsX3VybBgDIAEoCRILCgN1cmwYBCABKAkSEwoLZXh0ZXJuYWxfaWQYBSABKAkSFQoNZXh0ZXJuYWxfa2luZBgGIAEoCUIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_planners_v1_resources_attachment_kind]);

/**
 * Describes the message studyo.today.planners.v1.resources.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_attachment, 0);

